import { useCallback } from 'react';
import { uniqueId } from 'js/utils/methods.util';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';
import { IGNORE_LIMITS_NOTIFICATION } from '../../constants';

export const useGetPlayerTimeout = () => {
    const send = useGenericSend();

    return useCallback(async ({ count }: Types.IGetPlayerTimeoutRequestData): Promise<Types.IGetPlayerTimeoutResponseData> => {
        const { data } = await send<Types.IGetPlayerTimeoutRequestData, Types.IGetPlayerTimeoutResponseData>({
            ID: 89909,
            responses: [89911, 89900],
            description: 'Get player timeout',
            count,
            correlationId: uniqueId(`${IGNORE_LIMITS_NOTIFICATION}-`)
        });

        return data;
    }, [send]);
};
